import { render, staticRenderFns } from "./MenuBaseComponent.vue?vue&type=template&id=1aeea503&scoped=true"
import script from "./MenuBaseComponent.vue?vue&type=script&lang=js"
export * from "./MenuBaseComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuBaseComponent.vue?vue&type=style&index=0&id=1aeea503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeea503",
  null
  
)

export default component.exports